import { SaveResponse } from "../../models/api/save";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { ClientAcceptancesSTO } from "../../models/pending-approvals";
import { BaseApiService } from "../base/base-api.service";
import { ClientPendingApprovalsDTO } from "../../models/pending-approvals/client-pending-approvals-dto";

export class MyClientTeamPendingApprovalsApiService extends BaseApiService<
  ClientPendingApprovalsDTO,
  ClientAcceptancesSTO
> {
  constructor() {
    super({
      servicePath: "/ClientAcceptances",
      loadItemsPath: "/GetClientPendingAcceptances",
      saveItemsPath: "/SaveClientAcceptances",
    });
  }
}

export const saveClientAcceptances = async (acceptances: ClientAcceptancesSTO): Promise<SaveResponse> => {
  const response = await new MyClientTeamPendingApprovalsApiService().saveItems([acceptances]);

  toastifyResponse(response, "failed", "default_success_message", "default_cancellation_message", "error_saving_data");

  return response;
};
